import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { CustomerOrder } from './customer-order';
import { Pagination } from '../../quipli-service/pagination/pagination';
import { CustomerOrderParsers } from './customer-order-parsers';
import { handleCustomerPaginatedRequest, handleCustomerRequest } from '../customer-api-client';

export const useCustomerOrderApiV1 = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function getOrderById(orderId: number): Promise<CustomerOrder> {
    const config = {
      method: 'get',
      url: `${contextPath}quipli-service/customer-api/v1/orders/${orderId}`,
      headers: {
        'X-Tenant': tenant,
      },
    };
    const order = await handleCustomerRequest<CustomerOrderParsers.CustomerOrderJson>(config);
    return CustomerOrderParsers.toCustomerOrder(order);
  }

  async function listOrders(pageSize: number, pageNumber: number): Promise<Pagination<CustomerOrder>> {
    const config = {
      method: 'get',
      url: `${contextPath}quipli-service/customer-api/v1/orders`,
      headers: {
        'X-Tenant': tenant,
      },
      params: {
        pageSize,
        pageNumber,
      },
    };
    const { items, pagination } = await handleCustomerPaginatedRequest<CustomerOrderParsers.CustomerOrderJson>(config);
    return {
      items: items.map(CustomerOrderParsers.toCustomerOrder),
      pagination,
    };
  }

  return {
    getOrderById,
    listOrders,
  };
};
